/**
 * Custom shadows for the Hub theme. These are taken directly from the Design System.
 * https://www.figma.com/design/TGjQnNhMkUwLeoamZ6Ea7q/Design-System?node-id=96-448&m=dev
 */

const cardShadow =
  '0 0 2px 0 rgba(145, 158, 171, 0.20), 0 12px 24px -4px rgba(145, 158, 171, 0.12)';

const dropdownShadow =
  '0 0 2px 0 rgba(145, 158, 171, 0.24), -20px 20px 40px -4px rgba(145, 158, 171, 0.24)';

const dialogShadow = '-40px 40px 80px -8px rgba(145, 158, 171, 0.24)';

const z24Shadow = '0 24px 48px 0 rgba(145, 158, 171, 0.16)';

const z20Shadow = '0 20px 40px -4px rgba(145, 158, 171, 0.16)';

const z16Shadow = '0 16px 32px -4px rgba(145, 158, 171, 0.16)';

const z12Shadow = '0 12px 24px -4px rgba(145, 158, 171, 0.16)';

const z8Shadow = '0 8px 16px 0 rgba(145, 158, 171, 0.16)';

const z4Shadow = '0 4px 8px 0 rgba(145, 158, 171, 0.16)';

const z1Shadow = '0 1px 2px 0 rgba(145, 158, 171, 0.16)';

export const customShadows = {
  card: cardShadow,
  dropdown: dropdownShadow,
  dialog: dialogShadow,
  z24: z24Shadow,
  z20: z20Shadow,
  z16: z16Shadow,
  z12: z12Shadow,
  z8: z8Shadow,
  z4: z4Shadow,
  z1: z1Shadow,
};
